import type { ISetPushNotificationTokenCmd } from "@/data/commands/notification/SetPushNotificationTokenCmd";

import { BaseServiceDao } from "./BaseServiceDao";

export class NotificationDao extends BaseServiceDao {
    public static className = "NotificationDao";

    constructor() {
        super("notification");
    }

    public async setPushNotificationToken(cmd: ISetPushNotificationTokenCmd): Promise<void> {
        return this.post("push-notification-token", cmd);
    }
}
